module.exports = __webpack_public_path__ + "static/new-jersey-fa65d65345a4a41ae1a40f2c4aa1fa87.png";